
const state = {
  data: {},
  id: null,
  lesson_count: null,
  title: '',
  training_course_id: undefined,
}

export const requiredFields = [
  { key: 'title' },
  { key: 'training_course_id' },
]

export default state
